import { Component,ViewChild } from '@angular/core';
import { RouterModule, Routes, Route, RouterOutlet, CanActivate, CanDeactivate,  } from '@angular/router';
@Component({
  selector: 'Master',
  templateUrl: './Master.html',
  styleUrls: ['./Master.css'],
  
})

 
export class Master {

 
  //(activate)='onActivate($event)'
  onActivate(evt:any){

  }

}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MasterPage/Master.ts